import { Observable } from 'rxjs';

import { Threshold } from 'app/model/cris/threshold';

import { RestfulApiService } from './restful-api.service';

class ThresholdService extends RestfulApiService<Threshold> {
    public deploy(): Observable<void> {
        return this.http.post(`${this.getUrl()}/deploy`);
    }

    protected getFormName(): string {
        return 'thresholds';
    }

    protected getPath(): string {
        return `thresholds`;
    }
}

export const thresholdService = new ThresholdService();
